<script>
import { useUserStore, useStockStore, useAppUpdateStore, useAppSystemConfigStore } from "@/stores/index.js"
import { AppCheckUpdate } from "@/api/app.js"
import { HOME_PAGE } from "@/utils/index.js"
import { localeList, defaultLocale } from "@/app.config.js"
// #ifdef H5
import { getCurrentInstance } from "vue"
// #endif
export default {
	// #ifdef H5
	// H5 的 onPageNotFound 只在启动时触发一次，且此时 uni.reLaunch 会因无页面挂载被排队挂起；
	// 统一用路由守卫兜底：未匹配任何页面（含启动和手改地址栏）时改 hash 回首页。
	// vue-router 是 @dcloudio/uni-h5 的传递依赖，pnpm 下顶层不可直接 import，从全局属性取实例
	setup() {
		const router = getCurrentInstance()?.appContext?.config?.globalProperties?.$router
		router?.afterEach((to) => {
			if (!to.matched.length) {
				window.location.replace(`#${HOME_PAGE}`)
			}
		})
	},
	// #endif
	onLaunch: function () {
		console.log('App Launch')
		const stockStore = useStockStore();
		const userStore = useUserStore();
		const appUpdateStore = useAppUpdateStore();
		const appSystemConfigStore = useAppSystemConfigStore();

		// 老用户本地可能存着已下线的语言，导航栏标题和请求头 lang 都直接取 uni.getLocale()，需要重置
		if (!localeList[uni.getLocale()]) {
			uni.setLocale(defaultLocale);
		}

		// #ifdef APP-PLUS
		appUpdateStore.onCheckForUpdate();
		// #endif

		// #ifdef H5
		appSystemConfigStore.onGetSystemBasic().catch(() => {});
		// #endif

		// 获取市场列表
		stockStore.getMarketList()

		uni.onLocaleChange(() => {
			stockStore.getMarketList();
		})

		if (userStore.token) {
			userStore.onGetUserInfo();
		}
	},
	// 路由到不存在的页面时兜底跳首页（H5 走上面的路由守卫）
	onPageNotFound: function (res) {
		// #ifndef H5
		console.error('页面不存在', res)
		const path = res.path || ''
		// 首页本身找不到就不再跳，避免死循环
		if ((path.startsWith('/') ? path : `/${path}`) === HOME_PAGE) return
		uni.reLaunch({
			url: HOME_PAGE,
			fail: (err) => console.error('[router] 兜底跳首页失败', err)
		})
		// #endif
	},
	onShow: function () {
		console.log('App Show')
	},
	onHide: function () {
		console.log('App Hide')
	}
}
</script>

<style lang="scss">
/* #ifndef APP-NVUE */
/*每个页面公共css */
@import "@/styles/index.scss";
/* #endif */
</style>
